export default __webpack_public_path__ + "static/media/typegenerator.98bbde9e.svg";